import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { Chip } from "primereact/chip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatarCNPJ, formatarCPF, formatarParaMoedaBRL } from "../../../utils";
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";

export default function SCPC({
  scpc
}: {
  scpc: any
}) {
  const { t } = useTranslation();

  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
    return value.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
  };

  const getResumo = () => {
    const resumos: any[] = [];
    if(scpc.dados && scpc.dados.pefin && scpc.dados.pefin.registro && scpc.dados.pefin.registro.length > 0){
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Registros',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-calendar-clock',
        label: 'Última ocorrência',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total',
        value: '0'
      })
      let valorTotal = 0.0
      let quantidade = 0;
      let data:Date|null = null
      scpc.dados.pefin.registro.forEach((ocorrencia:any) => {
        quantidade ++;
        valorTotal = valorTotal + Number(ocorrencia.valor.replaceAll('.', '').replace(',', '.'))
        const [mes, ano, ] = ocorrencia.data_entrada.split(/[\/: ]/).map((v: string) => parseInt(v));
        const dataFormatada = new Date(ano, mes - 1);
        if(data == null || data < dataFormatada){
          data = dataFormatada
        }
        
      });
      resumos[1].value = (data ? formatDate(data) : '');
      resumos[0].value = quantidade;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }
    return resumos;
  }

  const getResumoProtesto = () => {
    const resumos: any[] = [];
    if(scpc.dados.protestos && scpc.dados.protestos.registro.length > 0){
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Comarcas',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-gauge',
        label: 'Quantidade Protestos',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total Protestos',
        value: '0'
      })
      let valorTotal = 0.0
      let quantidade = 0;
      const comarcas: any[] = []
      scpc.dados.protestos.registro.forEach((prot:any) => {
        quantidade ++;
        valorTotal = valorTotal + Number(prot.valor.replace('.', '').replace(',', '.'))
        if(!comarcas.includes(prot.origem)){
          comarcas.push(prot.origem)
        }
      });
      resumos[0].value = comarcas.length;
      resumos[1].value = quantidade;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }
    
    return resumos;
  }

 
  const numberFormat = (value:number, width:number) => {
    return new Array(width + 1 - (value + '').length).join('0') + value;
  }

  const headerTemplateProtesto = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {scpc.dados.protestos.registro && scpc.dados.protestos.registro.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('protestos')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('protestos')}</span>) }</div>;
  }


  const headerTemplatePefin = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {scpc.dados.pefin.registro && scpc.dados.pefin.registro.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pefins')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('pefins')}</span>) }</div>;
  }
  
 
  
  return (
    <div>
    {scpc.mensagemErro ? (<p>{scpc.mensagemErro}</p>) :
    (<div>
      {scpc.dados.dados_cadastrais.cpf &&(
        <div>
          <Panel header={t('consumidor')}>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('documento')}</label>
                      <Chip style={{width:"100%"}} label={formatarCPF(numberFormat(scpc.dados.dados_cadastrais.cpf, 11))} />
                  </div>
                </div>
                <div className="col">
                <div >
                      <label className="label-dados">{t('nome')}</label>
                      <Chip style={{width:"100%"}} label={scpc.dados.dados_cadastrais.nome} />
                  </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('nomeMae')}</label>
                      <Chip style={{width:"100%"}} label={scpc.dados.dados_cadastrais.nome_mae} />
                  </div>
                </div>
                <div className="col">
                    <div >
                      <label className="label-dados">{t('situacao')}</label>
                      <Chip style={{width:"100%"}} label={scpc.dados.dados_cadastrais.situacao} />
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('dataNascimento')}</label>
                      <Chip style={{width:"100%"}} label={scpc.dados.dados_cadastrais.data_nascimento} />
                  </div>
                </div>
                <div className="col">
              
                </div>
            </div>
          
          </Panel>
        

        </div>
      ) }
    {scpc.dados.dados_cadastrais.cnpj &&(
        <div>
          <Panel header={t('consumidor')}>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('documento')}</label>
                      <Chip style={{width:"100%"}} label={formatarCNPJ(numberFormat(scpc.dados.dados_cadastrais.cnpj, 14))} />
                  </div>
                </div>
                <div className="col">
                <div >
                      <label className="label-dados">{t('razaoSocial')}</label>
                      <Chip style={{width:"100%"}} label={scpc.dados.dados_cadastrais.razao_social} />
                  </div>
                </div>
            </div>
            <div className="grid">
                <div className="col p-fluid flex flex-wrap">
                  <div >
                      <label className="label-dados">{t('dataFundacao')}</label>
                      <Chip style={{width:"100%"}} label={scpc.dados.dados_cadastrais.data_fundacao} />
                  </div>
                </div>
                <div className="col">
                    <div >
                      <label className="label-dados">{t('situacao')}</label>
                      <Chip style={{width:"100%"}} label={scpc.dados.dados_cadastrais.situacao ? scpc.dados.dados_cadastrais.situacao : 'Não Informado'} />
                    </div>
                </div>
            </div>
           
          
          </Panel>
          <br></br>
          
          <Panel headerTemplate={headerTemplateProtesto}>
              {scpc.dados.protestos.registro.length === 0 ? ( <NadaConsta />) : (<>
              <div className="flex-consulta  flex-wrap gap-3">
                {getResumoProtesto().map((item:any, index:number) => (
                                  
                    <Card className='flex-1' style={{backgroundColor: '#2e2eb8'}} key={index}>
                        <div className="flex-consulta  justify-content-between gap-5">
                            <div className="flex-consulta  flex-column gap-1">
                                <span style={{color: 'white'}} className=" text-sm">{item.label}</span>
                                <span style={{color: 'white'}} className="font-bold text-lg">{item.value}</span>
                            </div>
                            <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor:'white' , color: '#183462' }}>
                                <i className={item.icon} />
                            </span>
                        </div>
                    </Card>
                  
                  ))}
              </div>
              <br></br>
              <DataTable size="small" value={scpc.dados.protestos.registro} tableStyle={{ minWidth: '50rem' }}>
                  <Column field="data_protesto" header={t('data')}></Column>
                  <Column field="cartorio" header={t('cartorio')}></Column>
                  <Column field="cidade" header={t('origem')}></Column>
                  <Column field="uf" header={t('uf')}></Column>
                  <Column field="valor" header={t('valor')}></Column>
              </DataTable>
              </>)}
          </Panel>
    
          
        

           
         
        </div>
      ) }

   
   
    <br></br>
    <Panel headerTemplate={headerTemplatePefin}>
        {scpc.dados.pefin.registro.length === 0 ? ( <NadaConsta />) : (<>
        <div className="flex-consulta  flex-wrap gap-3">
          {getResumo().map((item:any, index:number) => (
                            
              <Card className='flex-1' style={{backgroundColor: '#2e2eb8'}} key={index}>
                  <div className="flex-consulta  justify-content-between gap-5">
                      <div className="flex-consulta  flex-column gap-1">
                          <span style={{color: 'white'}} className=" text-sm">{item.label}</span>
                          <span style={{color: 'white'}} className="font-bold text-lg">{item.value}</span>
                      </div>
                      <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor:'white' , color: '#183462' }}>
                          <i className={item.icon} />
                      </span>
                  </div>
              </Card>
            
            ))}
        </div>
        <br></br>
        <DataTable size="small" value={scpc.dados.pefin.registro} tableStyle={{ minWidth: '50rem' }}>
            <Column field="data_entrada" header={t('data')}></Column>
            <Column field="contrato" header={t('contrato')}></Column>
            <Column field="avalista" header={t('natureza')}></Column>
            <Column field="tipo_ocorrencia" header={t('tipo')}></Column>
            <Column field="informante" header={t('informante')}></Column>
            <Column field="valor" header={t('valor')}></Column>
        </DataTable>
        </>)}
    </Panel>
    
    
    
      
      
 
 
    </div>)}
  </div>
  )
}